import { render } from "./objectiveControlsMap.vue?vue&type=template&id=9d87f6bc&scoped=true&ts=true"
import script from "./objectiveControlsMap.vue?vue&type=script&lang=ts"
export * from "./objectiveControlsMap.vue?vue&type=script&lang=ts"

import "./objectiveControlsMap.vue?vue&type=style&index=0&id=9d87f6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d87f6bc"]])

export default __exports__